import { Check, Copy, Pencil } from "lucide-react";
import React, {
  useState,
  useOptimistic,
  useTransition,
  useEffect,
} from "react";
import { Button } from "flowbite-react";




import { toast } from "sonner";

function JobDescriptions({ jobDescription, updatedJobDescription }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editDescription, setEditDescription] = useState(jobDescription);
  const [isPending, startTransition] = useTransition();
  const [optimisticDescription, setOptimisticDescription] = useOptimistic(
    editDescription,
    (state, newState) => newState
  );
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    setEditDescription(jobDescription);
  }, [jobDescription]);
  const handleEditClick = () => {
    setIsEditing(true);
    setOptimisticDescription(editDescription);
  };

  const handleSaveClick = () => {
    setIsEditing(false);
    startTransition(async () => {
      setOptimisticDescription(editDescription);
      const promiseResponse = async () =>
        await updatedJobDescription(editDescription);
      toast.promise(promiseResponse, {
        loading: "Updating job description",
        success: () => {
          return "Job description updated successfully";
        },
        error: (error) => {
          setOptimisticDescription(jobDescription);
          setEditDescription(jobDescription);
          return error.message;
        },
      });
    });
  };

  const handleChange = (e) => {
    setEditDescription(e.target.value);
  };

  const handleCopyToClipboard = () => {
    navigator.clipboard
      .writeText(optimisticDescription)
      .then(() => {
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 2000);
      })
      .catch((err) => { });
  };

  return (
    <div className="job-description">
      <div className="mb-4"></div>
      <div className="flex justify-between items-center flex-row">
        <h2 className="flex-grow text-h5">Job Description</h2>
      </div>
      <div className="mb-4"></div>
      <div className="text-gray-600">
        <p className="font-bold">
          Add all the important details about the job here.
        </p>
        <p>
          This will be used to evaluate candidates and answer their questions.
          It also includes the information you've already shared about the role.
          Don't include any private or confidential information.
        </p>
      </div>
      <div className="mb-8"></div>
      <div className="rounded border border-gray-200 p-4">
        <div className="flex gap-2 justify-end mb-4">
          <Button
            color="gray"
            className="border border-gray-300 mr-2"
            onClick={handleCopyToClipboard}
          >
            <div className="flex items-center">
              {copied ? (
                <Check size={20} className="mr-2 text-primary" />
              ) : (
                <Copy size="1em" className="mr-3 text-black" />
              )}
              {copied ? "Copied!" : "Copy to Clipboard"}
            </div>
          </Button>
          <Button
            color="gray"
            className="border border-gray-300 mr-2"
            onClick={handleEditClick}
          >
            <div className="flex items-center">
              <Pencil size="1em" className="mr-3 text-black" />
              Edit
            </div>
          </Button>
          <Button
            color="gray"
            className="text-purple-700 border border-purple-700"
            onClick={handleSaveClick}
            disabled={isPending}
          >
            <div className="flex items-center">
              <Check size="1em" className="mr-3 text-purple-700" />
              Save
            </div>
          </Button>
        </div>
        <div>
          {isEditing ? (
            <div>
              <textarea
                value={editDescription}
                onChange={handleChange}
                className="w-full h-64 bg-gray-100 text-black p-4 rounded-md border border-slate-300"
              />
            </div>
          ) : (
            <div className="bg-gray-100 rounded-md border border-slate-300 p-4">
              <p>{optimisticDescription}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default JobDescriptions;
